import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  SubTitle,
  ThirdTitle,
} from "../ContentsStyles";

const CG_8 = () => {
  return (
    <>
      <Parah>
        We believe that trust forms the foundation of our community. We do not
        allow activities that may undermine the integrity of our platform or the
        authenticity of our users. We remove content or accounts that involve
        spam or fake engagement, impersonation, or misleading information that
        causes significant harm.
      </Parah>
      <SubTitle>Spam and Fake Engagement</SubTitle>
      <Parah>
        Fake engagement includes any content or activity that seeks to
        artificially inflate popularity on the platform. We prohibit any
        attempts to manipulate the platform to increase interaction metrics.
      </Parah>
      <ThirdTitle>Do not:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Share instructions on how to artificially increase views, likes,
        followers, shares, or comments.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Engage in selling or buying views, likes, followers, shares, or
        comments.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Promote artificial traffic generation services.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Operate multiple Talents Explore accounts under false or fraudulent
        pretences to distribute commercial spam.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Create malicious software or modify code to artificially increase views,
        likes, followers, shares, or comments.
      </PointsWrapper>
      <SubTitle>Impersonation</SubTitle>
      <Parah>
        We do not allow accounts that pose as another person or entity in a
        deceptive manner. When we confirm a report of impersonation, we may ask
        the user to revise the profile or may ban the account. We do allow
        accounts that are clearly parody, commentary, or fan-based, such as
        where the username indicates that it is a fan, commentary, or parody
        account and not affiliated with the subject of the account.
      </Parah>
      <ThirdTitle>Do not:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Pose as another person or entity by using someone else's name,
        biographical details, or profile picture in a misleading manner.
      </PointsWrapper>
      <SubTitle>Harmful Misinformation</SubTitle>
      <Parah>
        Misinformation is defined as content that is inaccurate or false. We
        will remove misinformation that causes significant harm to individuals,
        our community, or the larger public regardless of intent. Significant
        harm includes serious physical injury, illness, or death; severe
        psychological trauma; large-scale property damage, and the undermining
        of public trust in civic institutions and processes such as governments,
        elections, and scientific bodies. This does not include simply
        inaccurate information, myths, or commercial or reputational harm.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Misinformation that incites hate or prejudice.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Misinformation related to emergencies that induces panic.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Medical misinformation that can cause harm to an individual's physical
        health.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that misleads community members about elections or other civic
        processes.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Conspiratorial content including content that attacks a specific person
        or a protected group, includes a violent call to action, or denies a
        violent or tragic event occurred.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Digital Forgeries (Synthetic Media or Manipulated Media) that mislead
        users by distorting the truth of events and cause significant harm to
        the subject of the video, other persons, or society.
      </PointsWrapper>
      <ThirdTitle>Do not:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Engage in coordinated inauthentic behaviour such as the use of multiple
        accounts to exert influence and sway public opinion while misleading
        individuals, our community, or our systems about the account's identity,
        location, relationships, popularity, or purpose.
      </PointsWrapper>
    </>
  );
};

export default CG_8;
